import { render, staticRenderFns } from "./cardsList.vue?vue&type=template&id=19cebf6a&scoped=true"
import script from "./cardsList.vue?vue&type=script&lang=js"
export * from "./cardsList.vue?vue&type=script&lang=js"
import style0 from "./cardsList.vue?vue&type=style&index=0&id=19cebf6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cebf6a",
  null
  
)

export default component.exports